// extracted by mini-css-extract-plugin
export default {"cover":"Cover_cover__MzqAQ","heading":"Cover_heading__xs9w8"};